import { templateTypes as content, blockTemplateTypes as blocks } from '../templates/templateTypes';
import { HeroSkeleton } from '../hero/skeleton/hero.skeleton.component';
import { ListSkeleton } from '../templates/blocks/list/skeleton/list.skeleton.component';
import { JumbotronSkeleton } from '../jumbotron/skeleton/jumbotron.skeleton.component';
import { EpgSkeleton } from '../templates/blocks/epg/skeleton/epg.skeleton.component';

export const BLOCKS = {
  [blocks.List]: ListSkeleton,
  [blocks.HorizontalEpg]: EpgSkeleton,
  [content.Hero]: HeroSkeleton,
  [content.Jumbotron]: JumbotronSkeleton,
};

export const DEFAULT_BLOCK_SKELETON = BLOCKS[blocks.List];

export const getBlockSkeleton = id => BLOCKS[id] || DEFAULT_BLOCK_SKELETON;
